import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Preference } from '../../../../avisDePub/preferences-avis-de-pub/model/preference';
import { Step2 } from '../../../../shared/models/component-messages/diveIN/step2';
import { PreferenceType } from '../../../../shared/models/enum/preferenceType';
import { TypeCPVClass } from '../models/TypeCPVClass';

@Component({
  selector: 'app-typeCPV-class',
  templateUrl: './typeCPV-class.component.html'
})
export class TypeCPVClassComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeCPVClass';
  @Input() parentForm: FormGroup;
  @Input() disabled: boolean;
  @Input() displayStar: boolean;
  @Input() objetPrincipal: TypeCPVClass;
  @Input() objetComplementaire: TypeCPVClass;

  @Output() preferenceSelected = new EventEmitter<Preference>();

  public step2 = new Step2();

  public typeCpv = PreferenceType.CODES_CPV;

  constructor() {
  }

  public ngOnInit() {
  }

  chargeDonneePreference(preference: Preference) {
    this.preferenceSelected.emit(preference);
  }

  public getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }
}

